import(/* webpackMode: "eager" */ "/mnt/octopus-tentacle-nova/application/Smokeball NOVA/Smokeball Staging/WebApp/3.1.441/webapp/app/error.tsx");
